import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const Help_Profile = () => {
    return (
        <HelpWindow title="Profile" >
            <Typography variant="body1" gutterBottom>
                Help for the subscriber profile

            </Typography>
        </HelpWindow>
    )
}

